/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bloc parc de l'écran de contractualisation (GLI/CBNO parc) : identité du parc et nombre de biens couverts. Mutuellement exclusif avec realEstate (mono-bien).
 * 
 * @export
 * @interface ContractualizationParcDto
 */
export interface ContractualizationParcDto {
    /**
     * 
     * @type {string}
     * @memberof ContractualizationParcDto
     */
    parcId: string;
    /**
     * Numéro de parc unique
     * @type {string}
     * @memberof ContractualizationParcDto
     */
    parcNumber: string;
    /**
     * Libellé du parc immobilier
     * @type {string}
     * @memberof ContractualizationParcDto
     */
    label: string;
    /**
     * Nombre de biens listés (GLI : biens couverts ; CBNO : tous les biens du parc)
     * @type {number}
     * @memberof ContractualizationParcDto
     */
    realEstateCount: number;
    /**
     * Nombre de biens couverts par le contrat
     * @type {number}
     * @memberof ContractualizationParcDto
     */
    coveredCount?: number;
}

/**
 * Check if a given object implements the ContractualizationParcDto interface.
 */
export function instanceOfContractualizationParcDto(value: object): value is ContractualizationParcDto {
    if (!('parcId' in value) || value['parcId'] === undefined) return false;
    if (!('parcNumber' in value) || value['parcNumber'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('realEstateCount' in value) || value['realEstateCount'] === undefined) return false;
    return true;
}

export function ContractualizationParcDtoFromJSON(json: any): ContractualizationParcDto {
    return ContractualizationParcDtoFromJSONTyped(json, false);
}

export function ContractualizationParcDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractualizationParcDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parcId': json['parcId'],
        'parcNumber': json['parcNumber'],
        'label': json['label'],
        'realEstateCount': json['realEstateCount'],
        'coveredCount': json['coveredCount'] == null ? undefined : json['coveredCount'],
    };
}

export function ContractualizationParcDtoToJSON(json: any): ContractualizationParcDto {
    return ContractualizationParcDtoToJSONTyped(json, false);
}

export function ContractualizationParcDtoToJSONTyped(value?: ContractualizationParcDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parcId': value['parcId'],
        'parcNumber': value['parcNumber'],
        'label': value['label'],
        'realEstateCount': value['realEstateCount'],
        'coveredCount': value['coveredCount'],
    };
}

